import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (costProfile) =>
    present(
      repository
        .removeCostProfile(costProfile)
        .then(() => costProfile)
        .catch(() => Promise.reject(costProfile)),
    );
}

export type { Interactor };

export { createInteractor };
